import { generateUrlWithQueryParameter, REMOVE_FALSY } from '@helpers/url';
import { getInfoBoxData } from 'services/datocms/product/infobox';

const VALID_STATUS = [200];

export async function getServerlessInfoBoxData({
  preview = false,
}: {
  preview: boolean;
}): Promise<any> {
  try {
    const url = generateUrlWithQueryParameter(
      `${process.env.NEXT_PUBLIC_HTTP_DOMAIN}/api/datocms/common-data/info-box`,
      {
        preview,
      },
      REMOVE_FALSY
    );
    const response = await fetch(url);
    if (!VALID_STATUS.includes(response.status)) {
      throw new Error(`Invalid response status ${response.status}`);
    }

    return await response.json();
  } catch (e) {
    return getInfoBoxData({
      preview,
    });
  }
}

export default getServerlessInfoBoxData;
